/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bowling'
export default icon
